import React from 'react';
import {config} from "../../config";
import Helmet from "react-helmet";

const PrivacyPolicy = (props) => {
    return (
        <div id={"privacyPolicy"}>
            <Helmet>
                <title>{config.preTitle}Politique de confidentialité{config.postTitle}</title>
            </Helmet>
            <div className={"container"}>
                <div className={"card big"}>
                    <h3>Privacy Policy</h3>

                    <p>Your privacy is important to us. To better protect your privacy we provide this notice explaining
                        our online information practices and the choices you can make about the way your information is
                        collected and used. To make this notice easy to find, we make it available in our footer and at
                        every point where personally identifiable information may be requested.</p>

                    <p>Log files are maintained and analysed of all requests for files on this website's web servers.
                        Log files do not capture personal information but do capture the user's IP address, which is
                        automatically recognised by our web servers.</p>

                    <h4>Our Commitment to Children's Privacy</h4>
                    <p>Protecting the privacy of the very young is especially important. For that reason, we never
                        collect or maintain information at our website from those we actually know are under 13, and no
                        part of our website is structured to attract anyone under 13.</p>

                    <h4>Cookies</h4>
                    <p>This website does not store any information that would, on its own, allow us to identify
                        individual users of this service without their permission. Any cookies that may be used by this
                        website are used either solely on a per session basis or to maintain user preferences. Cookies
                        are not shared with any third parties.</p>
                </div>
            </div>
        </div>
    )
};

export default PrivacyPolicy;